import { render, staticRenderFns } from "./AssignmentTab.vue?vue&type=template&id=a6f08216"
import script from "./AssignmentTab.vue?vue&type=script&lang=js"
export * from "./AssignmentTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports